/**
 * Classe de formatage des nombres
 */

export default class Number {

    // number: null,
    // locale: null, // 'fr' ou 'fr_FR'

    /**
     *
     * @param int|float number Nombre à formater
     * @param string locale Locale à utiliser
     */
    constructor(number, locale) {
        this.number = number;
        this.locale = locale
    };

    /**
     * Retourne le nombre formaté dans la langue
     * @param object options
     * @return string
     */
    format(options = {}) {
        return new Intl.NumberFormat(this.locale, options).format(this.number);
    }

    /**
     * Formate le montant en paramètres
     * @param int|float amount
     * @param string locale (fr, en...)
     * @returns string
     */
    static getAmountFormatted(amount, locale) {
        const value = new Number(amount.toFixed(2), locale);
        return value.format({
            style: 'currency',
            currency: 'EUR'
        });
    };

    /**
     * Retourne un entier entre les valeurs en paramètre
     * @param int min
     * @param int max
     * @return int
     */
    static random(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    };

}
